import { FilesIcon, PieChartIcon, ScaleIcon } from "./img/Ecosystem.icons";

export const ecosystemList = [
  { icon: PieChartIcon(), text: "Site owners get paid for leasing their data" },
  { icon: ScaleIcon(), text: "Site visitors get paid as anonymous data points" },
  { icon: FilesIcon(), text: "Advertisers pay to access this personalized data" },
];
